import { useRoutePlanFeedbackAccess as useAccessQuery } from 'api/route-plan-feedback/route-plan-feedback';
import Roles, { includesRoles } from 'constants/Roles';
import useAuthenticationState from 'contexts/authentication/useAuthentication';
import useMe from 'contexts/authentication/useMe';

/**
 * Får användaren svara på kvällens ruttprov, och ser hon vem som svarat?
 *
 * Trafikledare = har planerat minst ett uppdrag, eller står i ruttplaneringens skrivlista (106):
 * hela poängen är att fler än de som redan ger feedback i ruttplaneringen tycker till. Servern prövar samma sak i
 * RoutePlanFeedbackController — den här hooken styr bara vad som syns.
 */
const useRoutePlanFeedbackAccess = () => {
  const {
    state: { isAuthenticated },
  } = useAuthenticationState();
  const me = useMe();
  const isAdmin =
    isAuthenticated && me !== null && includesRoles([Roles.Admin], me.roles);

  const { data, isSuccess, isError } = useAccessQuery({
    query: { enabled: isAdmin, staleTime: 60 * 60_000 },
  });

  return {
    canGiveFeedback: isAdmin && (data?.canGiveFeedback ?? false),
    canSeeNames: isAdmin && (data?.canSeeNames ?? false),
    loaded: !isAdmin || isSuccess || isError,
  };
};

export default useRoutePlanFeedbackAccess;
